import React from 'react';
import styles from './NationalityCard.module.css';
import Flag from 'react-world-flags';
import { NationalityCode } from './NationalityCode.js';

const NationalityCard = ({ data }) => {
  const code = NationalityCode?.find((i) => data?.name == i.country)?.code;
  console.log('VFDv', code);
  return (
    <div className={styles['nationality_container']}>
      <div className={styles['space']}></div>
      <div className={styles['text_container']}>
        <h3>{data?.name === 'United Arab Emirates' ? 'UAE' : data?.name}</h3>
        <h4>{data?.number}</h4>
      </div>
      {/* <img src={flag} className={styles["flag"]} alt='Lebanon Flag' /> */}
      {code ? (
        <div className={styles.flagWrapper}>
          <Flag code={code} className={styles.flag} />
        </div>
      ) : (
        <img
          className={`${styles['flag']} ${styles['unknown_flag']} `}
          alt={`${data?.name} Flag`}
        />
      )}
    </div>
  );
};

export default NationalityCard;
